<template>
  <section class="admin-content">
    <Navbar />
    <main class="admin-main">

      <!-- ── Page Header ─────────────────────────────────────── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-home" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Health Facilities</h4>
              <small style="opacity: .8;">
                {{ Array.isArray(providers) ? providers.length : 0 }}
                {{ register.phc_type }} {{ register.phc_general }} providers
              </small>
            </div>
            <div class="ml-auto d-flex" style="gap: 8px;">
              <button class="btn btn-light btn-sm font-weight-bold px-3" @click="showsearch = !showsearch">
                <i class="fe mr-1" :class="showsearch ? 'fe-x' : 'fe-filter'"></i>
                Filter
              </button>
              <button class="btn btn-light btn-sm font-weight-bold px-3" @click="show = !show">
                <i class="fe mr-1" :class="show ? 'fe-minus' : 'fe-plus'"></i>
                {{ show ? 'Cancel' : 'Add Facility' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">


        <!-- ── Filter Form ─────────────────────────────────────── -->
        <div v-show="showsearch" class="card shadow form-card mb-4">
          <div class="form-card-header">
            <div class="section-number"><i class="fe fe-filter" style="font-size:12px;"></i></div>
            <h6 class="mb-0 font-weight-bold text-white">Filter Facilities</h6>
          </div>
          <div class="card-body px-4 pt-4 pb-3">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Search Provider</label>
                <v-select v-model="provider_id" :options="providers" label="agency_name"
                  :value="provider_id" @input="selected" placeholder="Search facility…" />
              </div>
              <div class="form-group col-md-3">
                <label class="small font-weight-bold text-secondary">Care Level</label>
                <select class="form-control" v-model="register.phc_type">
                  <option value="">All</option>
                  <option>Primary</option>
                  <option>Secondary</option>
                  <option>Tertiary</option>
                  <option value="Telemedicine">Telemedicine</option>
                </select>
              </div>
              <div class="form-group col-md-3">
                <label class="small font-weight-bold text-secondary">Facility Type</label>
                <select class="form-control" v-model="register.phc_general">
                  <option value="">All</option>
                  <option>Public</option>
                  <option>Private</option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label class="small font-weight-bold text-secondary">Status</label>
                <select class="form-control" v-model="register.status">
                  <option value="">All</option>
                  <option value="1">Approved</option>
                  <option :value="false">Pending</option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label class="small font-weight-bold text-secondary">LGA</label>
                <select class="form-control" v-model="filter.localgovt">
                  <option value="">All</option>
                  <option v-for="lga in lga_states" v-bind:key="lga" :value="lga.id">
                    {{ lga.local_name }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-2">
                <label class="small font-weight-bold text-secondary">Start Date</label>
                <input type="date" class="form-control" v-model="filter.from" />
              </div>
              <div class="form-group col-md-2">
                <label class="small font-weight-bold text-secondary">End Date</label>
                <input type="date" class="form-control" v-model="filter.to" />
              </div>
            </div>
            <div class="d-flex flex-wrap" style="gap: 8px;">
              <button class="btn btn-submit px-4" @click="getProviders">
                <i class="fe fe-filter mr-1"></i> Filter Results
              </button>
              <button class="btn btn-outline-secondary px-4" @click="getStats">
                <i class="fe fe-download mr-1"></i> Download Statistics
              </button>
              <download-excel :data="providers" :fields="json_fields"
                class="btn btn-outline-success px-4"
                header="Health Facility Data" :escapeCsv="false" name="Health Facility Data">
                <i class="fe fe-file-text mr-1"></i> Export Details
              </download-excel>
            </div>
          </div>
        </div>

        <!-- ── Add Facility Form ───────────────────────────────── -->
        <div v-show="show" class="card shadow form-card mb-4">
          <div class="form-card-header">
            <div class="section-number">1</div>
            <h6 class="mb-0 font-weight-bold text-white">Register New Health Facility</h6>
          </div>
          <div class="card-body px-4 pt-4 pb-3">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Contact Person First Name</label>
                <input type="text" required class="form-control" placeholder="First Name"
                  v-model="register.firstname" />
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Contact Person Last Name</label>
                <input type="text" required class="form-control" placeholder="Last Name"
                  v-model="register.lastname" />
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Facility Name</label>
                <input type="text" required class="form-control" placeholder="Facility Name"
                  v-model="register.agency_name" />
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Email</label>
                <input type="email" required class="form-control" placeholder="Email"
                  v-model="register.email" />
              </div>
              <div class="form-group col-md-4">
                <label class="small font-weight-bold text-secondary">Phone Number</label>
                <input v-phone type="text" pattern="\d*" required class="form-control"
                  placeholder="Phone Number" v-model="register.phone_number" />
              </div>
              <div class="form-group col-md-4">
                <label class="small font-weight-bold text-secondary">Address</label>
                <input class="form-control" v-model="register.address1" placeholder="Address" />
              </div>
              <div class="form-group col-md-4">
                <label class="small font-weight-bold text-secondary">Facility Code</label>
                <input class="form-control" v-model="register.facility_code" placeholder="Facility Code" />
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">LGA</label>
                <select class="form-control" v-model="register.localgovt" @change="fetchWards($event)">
                  <option v-for="lga in lga_states" v-bind:key="lga" :value="lga.id">
                    {{ lga.local_name }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Ward</label>
                <select class="form-control" v-model="register.ward">
                  <option v-for="ward in wards" v-bind:key="ward.id" :value="ward.id">
                    {{ ward.ward_name }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Care Level</label>
                <select class="form-control" v-model="register.sector">
                  <option>Primary</option>
                  <option>Secondary</option>
                  <option>Tertiary</option>
                  <option value="Telemedicine">Telemedicine</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Facility Type</label>
                <select class="form-control" v-model="register.phc_general">
                  <option>Public</option>
                  <option>Private</option>
                </select>
              </div>
            </div>
            <div class="d-flex justify-content-end" style="gap: 10px;">
              <button type="button" class="btn btn-outline-secondary px-4" @click="show = false">
                Cancel
              </button>
              <button type="button" class="btn btn-submit px-5" @click="registerUser">
                <i class="fe fe-plus mr-2"></i> Add Health Facility
              </button>
            </div>
          </div>
        </div>

        <!-- ── Providers Table ────────────────────────────────── -->
        <div class="card shadow table-card">
          <div class="d-flex align-items-center justify-content-between px-4 pt-4 pb-3">
            <div>
              <h6 class="mb-0 font-weight-bold text-dark">
                <i class="fe fe-home text-primary mr-2"></i> Registered Providers
              </h6>
              <small class="text-muted">
                {{ Array.isArray(providers) ? providers.length : 0 }} facility(ies)
              </small>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table mb-0">
              <thead class="table-head">
                <tr>
                  <th class="table-th px-4">SN</th>
                  <th class="table-th">Facility Name</th>
                  <th class="table-th">Type</th>
                  <th class="table-th">Ownership</th>
                  <th class="table-th">Facility Code</th>
                  <th class="table-th">Status</th>
                  <th class="table-th">Contact</th>
                  <th class="table-th">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(provider, index) in providers" v-bind:key="provider.id" class="table-row">
                  <td class="px-4 py-3 text-muted" style="font-size:.88rem;">{{ index + 1 }}</td>
                  <td class="py-3">
                    <router-link :to="{ path: '/provider-' + provider.id }" class="font-weight-bold" style="font-size:.88rem;">
                      {{ provider.agency_name }}
                    </router-link>
                  </td>
                  <td class="py-3">
                    <span class="rel-chip">{{ provider.phc_type }}</span>
                  </td>
                  <td class="py-3" style="font-size:.88rem;">{{ provider.phc_general }}</td>
                  <td class="py-3">
                    <span class="code-chip">{{ provider.facility_code }}</span>
                  </td>
                  <td class="py-3">
                    <button
                      class="btn btn-sm btn-outline-success"
                      @click="acceptProvider(provider)"
                      v-if="provider.status == false"
                    >
                      Approve
                    </button>
                    <span v-else-if="provider.status == 1" class="status-badge status-badge--approved" style="font-size:.7rem;">
                      approved
                    </span>
                    <span v-else class="status-badge status-badge--pending" style="font-size:.7rem;">
                      pending
                    </span>
                  </td>
                  <td class="py-3" style="font-size:.82rem;color:#64748b;">
                    {{ provider.phone_number }}<br/>
                    <small>{{ provider.email }}</small>
                  </td>
                  <td class="py-3">
                    <router-link :to="{ path: '/provider-' + provider.id }">
                      <button type="button" class="btn btn-sm btn-outline-primary">
                        <i class="fe fe-eye mr-1"></i> View
                      </button>
                    </router-link>
                  </td>
                </tr>
                <tr v-if="!providers || providers.length === 0">
                  <td colspan="8" class="text-center text-muted py-5">
                    <i class="fe fe-home" style="font-size:2rem;display:block;margin-bottom:8px;"></i>
                    No providers found
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
      <FacilityDuplicateModal :matches="duplicates.matches" :likely="duplicates.likely" :name="register.agency_name" :busy="linking"
        @cancel="duplicates = { matches: [], likely: 0 }" @add-anyway="addAnyway" @link="linkExisting" />
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import FacilityDuplicateModal from "./FacilityDuplicateModal.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: { FacilityDuplicateModal,
    Navbar,
    Loading,
  },
  data() {
    return {
      isAgencyStaff: ["shis", "employee"].includes((JSON.parse(localStorage.getItem("user") || "{}") || {}).type),
      duplicates: { matches: [], likely: 0 },
      linking: false,
      user: null,
      stats: "",
      providers: "",
      agencies: "",
      edit: false,
      show: false,
      showsearch: true,
      isLoading: false,
      fullPage: true,
      agency_id: "",
      provider_id: "",
      states: "",
      state: "",
      lga_states: "",
      sector: "",
      wards: [],
      filter: {
        from: "",
        to: "",
        localgovt: "",
      },
      json_fields: {
        "Facility ID": "id",
        "Facility Name": "agency_name",
        "Contact First Name": "firstname",
        "Contact Last Name": "lastname",
        "Contact Number": "phone_number",
        LGA: "local_name",
        Email: "email",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      register: {
        firstname: "Nil",
        lastname: "Nil",
        phone_number: "00000000000",
        email: "",
        type: "provider",
        facility_code: "",
        state: "",
        agency_name: "",
        ward: "",
        services_offered: "",
        localgovt: "",
        sector: "",
        address1: "",
        role: 0,
        phc_general: "",
        password: "euhler",
        password_confirmation: "euhler",
      },
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    selected(value) {
      this.selected_provider = value.id;
      this.$toasted.info("Searched Successfully", {
        position: "top-center",
        duration: 3000,
      });
      this.$router.push(`/provider-${this.selected_provider}`);
    },
    fetchLga() {
      this.axios
        .get(`/api/v1/auth/lga/2679`)
        .then((response) => {
          this.lga_states = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    // Checks the state for likely duplicates first; the dialog lets staff open/link the existing one or add anyway.
    registerUser() {
      if (!this.register.agency_name) return this.doRegister();
      this.isLoading = true;
      this.axios
        .post("/api/v1/auth/providers/duplicate-check", {
          agency_name: this.register.agency_name,
          facility_code: this.register.facility_code,
          phone_number: this.register.phone_number,
          email: this.register.email,
          localgovt: this.register.localgovt,
          ward: this.register.ward,
        })
        .then((res) => {
          this.isLoading = false;
          if (res.data.matches && res.data.matches.length) {
            this.duplicates = res.data;
          } else {
            this.doRegister();
          }
        })
        .catch(() => { this.isLoading = false; this.doRegister(); }); // the check never blocks adding
    },
    addAnyway() {
      this.duplicates = { matches: [], likely: 0 };
      this.doRegister();
    },
    linkExisting(m) {
      this.linking = true;
      this.axios
        .post("/api/v1/auth/providerApply", { provider_id: m.id, agency_id: 407465, status: true })
        .then(() => {
          this.$toasted.success(`${m.agency_name} is now linked to your agency.`, { position: "top-center", duration: 5000 });
          this.duplicates = { matches: [], likely: 0 };
          this.show = false;
          this.getProviders();
        })
        .catch(() => this.$toasted.error("Could not link the facility.", { position: "top-center", duration: 4000 }))
        .finally(() => { this.linking = false; });
    },
    doRegister() {
      this.isLoading = true;
      this.axios
        .post("/api/v1/auth/registerProvider", {
          firstname: this.register.firstname,
          lastname: this.register.lastname,
          facility_code: this.register.facility_code,
          email: this.register.email,
          phone_number: this.register.phone_number,
          agency_name: this.register.agency_name,
          type: this.register.type,
          state: "2680",
          localgovt: this.register.localgovt,
          services_offered: this.register.services_offered,
          address1: this.register.address1,
          ward: this.register.ward,
          enrolled_by: this.user.id,
          user_role: this.register.role,
          org_id: 10,
          password: this.register.password,
          password_confirmation: this.register.password_confirmation,
          phc_sector: this.sector,
          phc_type: this.register.sector,
          phc_general: this.register.phc_general,
        })
        .then((response) => {
          let user_id = response.data.data.id;

          //add provider
          this.show = false;
          this.axios
            .post("/api/v1/auth/providerApply", {
              provider_id: user_id,
              agency_id: 407465,
              status: true,
            })

            .then((response) => {
              console.log(response);
              this.$toasted.info("Provider added Successfully!", {
                position: "top-left",
                duration: 5000,
              });
              this.$router.push(`/provider-${user_id}`);
            })
            .catch((error) => {
              console.log(error.response);
            });
          //end of provider

          console.log(response);
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error.response);
          this.isLoading = false;
          this.$toasted.error("Sign up not Successful", {
            position: "top-left",
            duration: 5000,
          });
        });
    },
    getProviders() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/providerAgency/407465`, {
          params: {
            phc_type: this.register.phc_type,
            phc_general: this.register.phc_general,
            status: this.register.status,
          },
        })
        .then((response) => {
          this.providers = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getStats() {
      this.isLoading = true;

      this.axios
        .get(`/api/v1/auth/provider/stats`, {
          params: {
            agency_id: 407465,
            from: this.filter.from,
            to: this.filter.to,
            localgovt: this.filter.localgovt,
          },
        })
        .then((response) => {
          this.stats = response.data.data
            .filter((item) => item.total > 0)
            .map((item) => ({
              ...item,
              facility_name: item.facility_name ?? item.agency_name,
            }));
          this.isLoading = false;

          const columns = ["facility_name", "local_government", "dependants_count", "enrollees_count", "female_count", "male_count", "total"];
          const rows = this.stats.map((item) =>
            columns.map((col) => `"${item[col] ?? ""}"`).join(",")
          );
          const csv = [columns.join(","), ...rows].join("\n");
          const blob = new Blob([csv], { type: "text/csv" });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `provider_stats_${new Date().toISOString().slice(0, 10)}.csv`;
          a.click();
          URL.revokeObjectURL(url);

          this.$toasted.info("Downloaded Successfully!", {
            position: "top-left",
            duration: 5000,
          });
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },

    fetchWards() {
      this.axios
        .get(`/api/v1/auth/getwards/` + event.target.value)
        .then((response) => {
          this.wards = response.data.data;
          console.log(response.data.data);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    clearIt() {
      this.agency_id = "";
    },

    updateCode(provider) {
      this.isLoading = true;

      this.axios
        .patch(`/api/v1/auth/updateFacilityCode`, {
          id: provider.id,
          facility_code: provider.facility_code,
        })
        .then((response) => {
          console.log(response);
          this.$toasted.success("Changed Successfully", {
            position: "top-center",
            duration: 3000,
          });
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.$toasted.error("Error!", {
            position: "top-center",
            duration: 3000,
          });
          this.isLoading = false;
        });
    },

    acceptProvider(provider) {
      this.isLoading = true;
      this.axios
        .post("/api/v1/auth/approveDisapproveProviderByAgency", {
          agency_id: 407465,
          provider_id: provider.id,
          status: 1,
        })
        .then((response) => {
          console.log(response);
          this.$breadstick.notify("Provider Updated!", {
            position: "top-right",
          });
          this.isLoading = false;
          this.getProviders();
        })
        .catch((error) => {
          console.log(error.response);
          this.isLoading = false;
        });
    },
  },
  created() {
    // the Providers menu links here with ?add=1 (?add=telemedicine) to open the add form
    if (this.$route.query.add) { this.show = true; if (this.$route.query.add === "telemedicine") this.register.sector = "Telemedicine"; }
    this.fetchLga();
    this.getProviders();
  },
};
</script>
